import { type CarrierDef } from '../common.js'
import {
  accountNumber,
  apiKey,
  password,
  username,
  userPassMap,
} from '../internal.js'

const credentialTypes = [username, password, apiKey] as const
const locationCredentialTypes = [accountNumber] as const

export type pensCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const pens: CarrierDef<pensCredType> = {
  name: 'Peninsula Truck Lines',
  scac: 'pens',
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    {
      id: 'guaranteed_nine_am',
      name: 'Guaranteed By 9:00 AM',
      guaranteed: true,
      guaranteedByTime: '09:00',
    },
    {
      id: 'guaranteed_twelve_pm',
      name: 'Guaranteed By Noon',
      guaranteed: true,
      guaranteedByTime: '12:00',
    },
  ],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['account-number', 'ref1'],
    ['api-key', 'apiKey'],
  ],
  engineLayers: [
    'provisioning',
    'rating',
    'pickup',
    'tracking',
    'profinder',
    'bol',
  ],
  credentialConfig: {
    'account-number': { customerIdentifier: true },
  },
}
